export const BASE_URL_LOCAL = `./data/`;
// export const BASE_URL_API = `https://superapi.rest/prof_interior/api`;
export const BASE_URL_API = `https://dsftt.online/api`;
// export const BASE_FILE_URL = `https://objectstorage.ca-toronto-1.oraclecloud.com/p/jE02KCLipZSKqdPxfle5ABFxoo3kkhQaCZySIYDoeGA5vq21F6brBA1inVn0dds4/n/yzfveo9zjrvn/b/bucket-20230109-1321/o`;

export const BASE_FILE_URL = `https://objectstorage.ca-toronto-1.oraclecloud.com/p/c9-CoS7IxGu1gJzQcASdyYG95zk1bv_sdaJaD09KOicAhybuKOmADeWRxqVYm7Y7/n/yzfveo9zjrvn/b/bucket-20230109-1321/o`;